import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';

interface ShortTextSetting {
    value: string;
    label: string;
    helptext?: string;
    required: boolean;
    minLength?: number;
    maxLength?: number;
    regex?: string;
    readonly: boolean;
    name: string;
}

@Component( {
    selector: 'his-short-text-job-setting',
    templateUrl: './his-short-text-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class HisShortTextJobSettingComponent {
    setting = input.required<ShortTextSetting>();
    private baseGlobalService = inject( HisBaseGlobalsService );

    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    } );
}
